import { render, staticRenderFns } from "./addGroupDialog.vue?vue&type=template&id=239c712c&scoped=true"
import script from "./addGroupDialog.vue?vue&type=script&lang=js"
export * from "./addGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./addGroupDialog.vue?vue&type=style&index=0&id=239c712c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239c712c",
  null
  
)

export default component.exports